import React from 'react';
import { Formik, Form } from 'formik';
import Input from '../../input'
import ButtonContained from '../../button';
import Modal from '../../modals/Modal'
import { AddBrandSchema } from '../../../validation/ValidationSchema';
import { api } from '../../../api/';
import { toast } from "react-toastify";

const EditBrand = props => {

    const { showEditBrandModal, setShowEditBrandModal, closeModal, brand,token,setListingReset } = props

    return (
        <Modal
        id="edit_brand"
        showModal={showEditBrandModal}
        closeModal={closeModal}
        modalHeader="Edit Brand"
        buttonText="SAVE">
        <Formik
            enableReinitialize
            validationSchema={AddBrandSchema}
            initialValues={{
                brandId: brand.brandId,
                BrandName: brand.brandName,
                CompanyName: brand.brandCompanyName,
                website: brand.brandWebsite,
                brandApiAccess:brand.brandApiAccess,
            }}
            onSubmit={(values,  {resetForm}) => {
                const formBody = {
                    brandId: brand.brandId,
                    brandName: values.BrandName,
                    brandCompanyName: values.CompanyName,
                    brandWebsite: values.website,
                    brandApiAccess:values.brandApiAccess
                }
                api.brands.update(formBody,token).then(res => {
                  
        
                    if (res.success === false) {
                        // toaster(res.message,'error')
                        
                         toast.error(res.message);
                         resetForm()
                      }
                      else {
                        // toaster(res.message,"success")
                        // setUpdateData(true)
                        setShowEditBrandModal(false)
                        setListingReset(prev => !prev);
                        resetForm();
                        toast.success("Brand Updated successfully!");
                      }                 
                  })
                  .catch(err => {
                    console.log("Caught Error:", err);
                    resetForm()
                    alert('error');
                  })
            }}

        >

{({
                handleSubmit,
                handleChange,
                handleBlur,
                values,
                touched,
                isValid,
                errors,
                isSubmitting,
                setFieldValue
            }) => {

                return (
                    <div className="container-fluid">
                        <div className="row">
                            <div className="col-sm-12">
                                <div className="box-row">
                                <div className="table-head ">
                                        {/* <h1 className="sec-header row align-items-center">Edit Brands</h1> */}
                                    </div>

                                    <div className="card"  style={{margin: '0px'}}>
                                        {/* <div className="card-header card-header-title">Brand Details */}
                                 
                                        {/* </div> */}
                                        <div className="card-body gatepass-saveoutput">
                                            <div className="reports">
                                                <Form onSubmit={handleSubmit}>
                                                <div className="form-row">
                                                    <label style={{top: '26px'}}  className="col-sm-3 col-form-label">Brand Name</label>
                                                        <div className="form-group  col-md-7">
                                                                <Input
                                                                    id="BrandName"
                                                                    name="BrandName"
                                                                    placeholder="Brand Name"
                                                                    type="text"
                                                                    value={values.BrandName}
                                                                    onChange={handleChange}
                                                                    error={touched.BrandName && errors.BrandName}
                                                                    errorText={errors.BrandName}
                                                                    disabled={isSubmitting} />
                                                        </div>
                                                    </div>  
                                                    <div className="form-row">  
                                                    <label style={{top: '26px'}} className="col-sm-3 col-form-label">Company Name</label>
                                                        <div className="form-group col-md-7">
                                                            <Input
                                                                id="CompanyName"
                                                                name="CompanyName"
                                                                placeholder="CompanyName"
                                                                type="text"
                                                                value={values.CompanyName}
                                                                onChange={handleChange}
                                                                error={touched.CompanyName && errors.CompanyName}
                                                                errorText={errors.CompanyName}
                                                                disabled={isSubmitting} />
                                                        </div>
                                                    </div>  
                                                         <div className="form-row">  
                                                    <label style={{top: '26px'}} className="col-sm-3 col-form-label">Website </label>
                                                        <div className="form-group col-md-7">
                                                            <Input
                                                                id="website"
                                                                name="website"
                                                                placeholder="Website"
                                                                value={values.website}
                                                                onChange={handleChange}
                                                                error={touched.website && errors.website}
                                                                errorText={errors.website}
                                                                disabled={isSubmitting} />
                                                        </div>
                                                    </div>
                                                       

                                                    <div className="form-row">
                                                        <div className="form-group col-md-12 mt-2" style={{display: 'flex',  justifyContent: 'center'}}>
                                                            <span className="custom-control custom-checkbox">
                                                            <input
                                                            checked={values.brandApiAccess}
                                                                    disabled={isSubmitting}
                                                                    style={{ zIndex: '100' }}
                                                                    type="checkbox"
                                                                    className="custom-control-input"
                                                                    id="customCheck"
                                                                    name="brandApiAccess"
                                                                    value={values.brandApiAccess}
                                                                    onChange={(e) => { setFieldValue('brandApiAccess', e.currentTarget.checked) }}>
                                                                </input>
                                                                <label className="custom-control-label" htmlFor="customCheck">API Access</label>
                                                              
                                                         
                                                            </span>
                                                        </div>
                                                    </div>
                                                    <div className="row">
                                                        <div className="col text-center">
                                                            <ButtonContained buttonName="Update" disabled={isSubmitting} />
                                                        </div>
                                                    </div>
                                                </Form>
                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                )
            }}
        </Formik>    
    </Modal>
    );

}

export default EditBrand;